var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressContainer"},[_c('v-progress-circular',{attrs:{"size":"100","value":_vm.progress}}),_c('p',{staticStyle:{"margin-top":"50px"}},[_vm._v("Opening file...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }